import { Component, computed, input, model } from '@angular/core';
import { CategoryKycConfig, RealmConfig } from '@/lib-backend';
import { sourceLabel } from '@/app/utils/inheritance';
import { Tag } from 'primeng/tag';
import { CategoryKycForm } from '@/app/components/category-config/category-kyc-form';
import { OverridableSection } from '@/app/components/category-config/overridable-section';

@Component({
    selector: 'app-website-info-kyc',
    standalone: true,
    imports: [Tag, CategoryKycForm, OverridableSection],
    templateUrl: './kyc-tab.html',
})
export class KycTab {
    readonly realm = input.required<RealmConfig>();
    readonly draft = model.required<CategoryKycConfig>();
    readonly overridden = model.required<boolean>();

    protected readonly section = computed(() => this.realm().CategorySpecific.Kyc);
    protected readonly sumsub = computed(() => this.realm().CategorySpecific.Sumsub);
    protected readonly sumsubSourceLabel = computed(() => sourceLabel(this.sumsub().Source));

    protected readonly dirty = computed(() =>
        this.overridden() !== this.section().IsOverridden ||
        JSON.stringify(this.draft()) !== JSON.stringify(this.section().Effective)
    );

    protected onToggle(value: boolean): void {
        this.overridden.set(value);
        if (!value) {
            this.draft.set(clone(this.section().Inherited));
        }
    }

    protected resetAll(): void {
        const s = this.section();
        this.draft.set(clone(s.Effective));
        this.overridden.set(s.IsOverridden);
    }
}

function clone<T>(v: T): T {
    return JSON.parse(JSON.stringify(v));
}
